module.exports = __webpack_public_path__ + "img/西安交通.b6599a7a.png";